
// search index
document.addEventListener("turbo:load", () => {
  const searchField = document.getElementById("fundraiser_search_input");
  if (!searchField) return;

  console.log("Load: fundraisers/search.js");

  searchField.addEventListener("input", (e) => {
    if (e.target.value === "") {
      e.target.form.requestSubmit(); // re-run the form when cleared
    }
  });
});

document.addEventListener("turbo:load", () => {
  const clearBtn = document.getElementById("clear_search_filters");
  if (!clearBtn) return;

  clearBtn.addEventListener("click", () => {
    const form = clearBtn.closest("form");
    if (!form) return;

    const searchInput = document.getElementById("fundraiser_search_input");
    if (searchInput) searchInput.value = "";

    form.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
      cb.checked = false;
    });

    form.requestSubmit();
  });
});
